import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)


axios.interceptors.request.use(config => {
  store.commit('setLoader', true)
  return config
});

axios.interceptors.response.use(response => {
    setTimeout(() => {
        store.commit('setLoader', false)
    },600)
  return response
})


export const store = new Vuex.Store({
    state: {
        apiUrl: "https://webapi.porscheinterauto.com.pl/",
        loader: false,
        offers:{},
        request: {
            // url_brand: 'audi',
            // url_model:'',
            model_id: '',
            limit: 70,
            page: 1,
            brand_id: 9,
            order: 1,
            type_id: 1,
            // registered: 1,
            city_names:[
              'Poznań'
            ],
            vins:[
              "WAUZZZ8V2KA118921",
              "WAUZZZ8V8KA114369",
              "WAUZZZF44KA118591",
              "WAUZZZF54KA027703",
              "WAUZZZF2XKN084132",
              "WAUZZZFY0K2109335",
              "WAUZZZFY1K2117458",
              "WAUZZZFY4K2115090",
              "WAUZZZFY4K2088425"
            ]

        },
        selectedOffer:false
    },
    getters: {
        getOffers: state => {
            return state.offers;
        },
        getCurrentModel: state => {
            // return state.request.url_model.replace(",", "");
        },
        getLoader: state => {
            return state.loader;
        },
        getSelectedOffer: state => {
            return state.selectedOffer;
        }
    },
    mutations: {
        setOffers: function(state, newState) {
            state.offers = newState;
        },
        setLoader: function(state, newState){
            state.loader = newState;
        },
        setModel: function (state, newState) {
            state.request.limit = 200;
            state.request.model_id = newState+',';
        },
        setSelectedOffer: function (state, newState) {
            state.selectedOffer = newState;
        }
    },
    actions:{
        async downloadOffers({ commit, state }) {
            // var request = {
            //   ...state.request
            // };
            // request.url_params = request.url_params.join(',')
            const { data } = await axios.get(state.apiUrl+'cars', {
                params: state.request
            });
            commit('setOffers', data);
        },
        downloadModel({dispatch,commit}, payload) {
            commit('setModel', payload);
            dispatch('downloadOffers');
        }
    }

})
